export default "__VITE_ASSET__lWjVU_ev__"